//if (window.species==undefined) window.species='sbarnacle';		
//if (window.species==undefined) window.species='igreylag';		
if (window.species==null) window.species='igreylag';		
import map from '../map'
import KML from 'ol/format/KML';
import GeoJSON from 'ol/format/GeoJSON';
import Feature from "ol/Feature";
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import LayerGroup from 'ol/layer/Group';
import Point from 'ol/geom/Point';
//import LineString from 'ol/geom/LineString';

import feature_get_layer from '../feature_get_layer';
import {Circle, Fill, Text, Stroke, Style} from 'ol/style';
const { ajax, toggleLayer, zoomToFit, animStyle, animate , tagStyle, getLayerByName} = require('../tele_funcs');

//unloadedLayers=new Object; //Used to check that all features are loaded (using featuresloadend event)
var unloadedLayers={};
// These get selected on webpage
var enddate;		
window.enddate='';		
window.detail=50;		

// Default as yesterday
var days=2;
var sdate = new Date();
sdate.setDate(sdate.getDate() - days);
window.startdate=sdate.toISOString().substring(0,10);

var layers;
getTelemetryData(window.startdate,window.species,'Geese','plotgeojson');
window.toggleLayer=toggleLayer;
window.zoomToFit=zoomToFit;
window.getLayerByName=getLayerByName;
window.removeTagLayers=removeTagLayers;
window.getTelemetryData=getTelemetryData;
window.replaceSource=replaceSource;
window.tagStyle=tagStyle;
window.animStyle=animStyle;
window.animate=animate;
/************ End of script ****************************/




/************ Functions ********************************/

function removeTagLayers(){
// NB needs modifying to identify correct layer group rather than just 2nd item in array 
if(map.getLayers().getArray().length <2) return;	

var group=map.getLayers().getArray()[2];// Should test for non-base and not Screen instead
console.log('Group Layer1: '+ group);
var x=group.getLayers();
	console.log(x);
//	console.log('There are '+x.getlength()+' layers');
	x.forEach(layer=>{
	//	if (x.getLength()>0) // all layergroup being emptied
			x.pop();
	});
//group.pop(); // Remove grouplayer too
map.getLayers().remove(group);
console.log(map.getLayers());
legend.getItems().clear();
// map.getLayers().forEach(layer=>{
//   if(layer.get('title')=='Geese') //remove whole layergroup
//	map.removeLayer(layer);
// })

/*   The following doesn't remove any of the layers in the layergroup
map.getLayerGroup().getLayersArray().slice.forEach(function(obj,idx){
//console.log(obj.get("ptt"));
if(typeof obj.get('ptt') != 'undefined'){
	console.log(obj,idx);
	map.removeLayer(obj);
}
});
*/
}

function getTelemetryData(startdate1,species1,groupName,format){
	layers= new Array();
	var ptts=JSON.parse(ajax("proxy.php/telemetry/subjectlistpg/species/"+species1+"/date_start/"+startdate1));

	for(var ptt in ptts){
		var url='proxy.php/Telemetry/'+format+'/ptt/'+ptts[ptt][0]+'/minqual/5/startdate/'+startdate1';
		if(window.enddate !='') url+='/enddate/'+window.enddate;
		if(window.detail !='') url+='/moved/'+window.detail/1000;

		loadTelemetry(ptts[ptt],species1,telemetrySource(url,format),tagStyle);
		addBirdToLegend(legend,ptts[ptt]);
	}
	console.log('layers');
	console.log(layers);
	var geese = new LayerGroup({ layers:layers, title: groupName, visible:true});
		map.addLayer(geese);
}

function replaceSource(urlChanges){ /* Same species and ptt list but changed e.g. date*/
	if(window.species=='') return; // Can't use empty species
	/*Need to loop through all of the existing layers for layerGroup and replace the url*/
var x=map.getLayerGroup('Geese').getLayersArray().forEach(function(layer,index){
	console.log('replace source',layer);
});
	removeTagLayers();
	getTelemetryData(window.startdate,window.species,'Geese','plotgeojson')
}

function telemetrySource(url,format){
	//if(format=='plotgeojson')
	if(format=='kmlplot2pg')
		format=new KML({extractStyles: false,extractAttributes: false,}); // kml file attributes are incompatible !!!!
	else
		format= new GeoJSON(); 
var vs=	new VectorSource({
	projection: map.displayProjection,
	  crossOrigin: 'anonymous',
	format: format,
	url: url,
});
	unloadedLayers[vs.ol_uid]=true;
	//console.log('load',unloadedLayers);
	vs.on('featuresloadend',layerloaded );
	vs.on('addfeature',addfeat );
	return vs;
}

console.log("5");

function loadTelemetry(ptt,species,source,styleFunc){
var vl=			new VectorLayer({
				title: ptt[2],
				ptt: ptt[0],
				color: ptt[1],
				species: species,
				style:	styleFunc,
				source: source,
			})
//	console.log('load source',vl);
vl.on('change:visible',function(){zoomToFit();});
layers.push(vl);
}
console.log("6");


function addBirdToLegend(legend,ptt){
legend.addItem({ 
	title: ptt[2],
	name: ptt[0],
	className: ptt[2],
	style: new Style ({
		image: new Circle ({
			radius: 7, 
			fill: new Fill ({
				color: ptt[1],
			}),
			stroke: new Stroke ({
				width: 1,
				color: ptt[1],
			})
		})
	}),
	typeGeom: 'Point',
});

}

function addfeat(evt) {
var color=evt.feature.getLayer(map).get('color');
	evt.feature.set('color',color);
}

function layerloaded(extent, resolution, projection, success, failure) {
//	console.log('unloaded',this.ol_uid,unloadedLayers);
//	var coordinates = [];
//	this.getFeatures().forEach(function(feat){
//		coordinates.push(feat.getGeometry().getCoordinates());
//	});

//	this.addFeatures([new Feature({
//		geometry: new LineString(coordinates),
//	})]);

	// now index the rows to allow easy access of prev and nect point in style function
	console.log(this);
	this.forEachFeature(function (feature){	feature.setId(feature.get('rownum'))});


	//Remove this layer from list of layers still to be loaded
	delete unloadedLayers[this.ol_uid];
	if(Object.keys(unloadedLayers).length==0) {
		zoomToFit(); // Last layer just fully loaded
	}
}

console.log("end");
